/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_DescriptionInputs */

const en_guide_json_syntax_errors_description = /** @type {(inputs: Guide_Json_Syntax_Errors_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn to identify and fix the most common JSON syntax errors. Practical examples and solutions for every JSON mistake.`)
};

const ko_guide_json_syntax_errors_description = /** @type {(inputs: Guide_Json_Syntax_Errors_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 흔한 JSON 구문 오류를 식별하고 수정하는 방법을 배워보세요. 모든 JSON 실수에 대한 실용적인 예제와 해결책을 제공합니다.`)
};

const ja_guide_json_syntax_errors_description = /** @type {(inputs: Guide_Json_Syntax_Errors_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も一般的なJSON構文エラーの特定と修正方法を学びましょう。すべてのJSONミスに対する実践的な例と解決策。`)
};

/**
* | output |
* | --- |
* | "Learn to identify and fix the most common JSON syntax errors. Practical examples and solutions for every JSON mistake." |
*
* @param {Guide_Json_Syntax_Errors_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_description = /** @type {((inputs?: Guide_Json_Syntax_Errors_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_description(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_description(inputs)
	return ja_guide_json_syntax_errors_description(inputs)
});